import React from 'react'
import whatsapp from '../images/whatsapp.svg'

const Whatsapp = () => {
  return (
    <div className='z-20 fixed right-[1%] bottom-[3%]'>
      <a
      href="https://wa.me/917901712453"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 animate-bounce   text-white px-4 py-2 rounded-md  transition duration-300"
    >
      <img
        src={whatsapp}
        alt="WhatsApp"
        className="w-20 h-20 "
      />
      </a>
    </div>
  )
}

export default Whatsapp
